import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isCSPLiveOnboarding", "isDotShown", "increaseZIndex"];
import React, { forwardRef } from 'react';
import { CSPButton, CSPButtonIcon } from './styles';
import { StudyPackIcon } from '@chegg-ui/theme';
import { useWindowDimensions } from '../useWindowDimensions';
import { StudyPackButtonTestId, StudyPackButtonTitle } from './types';
export var StudyPackButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isCSPLiveOnboarding = _ref.isCSPLiveOnboarding,
      isDotShown = _ref.isDotShown,
      increaseZIndex = _ref.increaseZIndex,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  if (!isCSPLiveOnboarding && width <= 1042) return /*#__PURE__*/React.createElement(CSPButtonIcon, _extends({}, rest, {
    ref: ref,
    "data-test": StudyPackButtonTestId.StudyPackIcon,
    increaseZIndex: increaseZIndex
  }), /*#__PURE__*/React.createElement(StudyPackIcon, {
    size: 'medium'
  }));
  var dataTest = isCSPLiveOnboarding ? StudyPackButtonTestId.StudyPackLive : StudyPackButtonTestId.StudyPack;
  var buttonLabel = isCSPLiveOnboarding ? StudyPackButtonTitle.StudyPackLive : StudyPackButtonTitle.StudyPack;
  return /*#__PURE__*/React.createElement(CSPButton, _extends({}, rest, {
    isDotShown: isDotShown,
    ref: ref,
    "data-test": dataTest,
    increaseZIndex: increaseZIndex
  }), buttonLabel);
});
StudyPackButton.displayName = 'StudyPackButton';
export default StudyPackButton;